import type { IUpdateRoomKioskHeaderCmd } from "@/data/commands/room/UpdateRoomKioskHeaderCmd";
import { Factory } from "@/data/dao/Factory";
import { RoomDao } from "@/data/dao/service/RoomDao";
import type { IRoomWithService } from "@/data/model/Room";

import { MultiLanguageInput } from "@/portal/formControls/MultiLanguageInput";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class RoomKioskForm extends BaseEntityForm<IRoomWithService, IUpdateRoomKioskHeaderCmd> {
    private headerField: MultiLanguageInput;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (i, d) => Factory.getInstance<RoomDao>(RoomDao).updateKioskHeader(i, d),
        });

        this.headerField = MultiLanguageInput.fromInput(this.$form.find('.form-control[name="kioskheader"]'));
    }

    public setFormData(model?: IRoomWithService) {
        this.headerField.setValues(model === undefined ? undefined : model.kioskHeader);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): IUpdateRoomKioskHeaderCmd {
        return {
            header: this.headerField.getValues(),
        };
    }
}
